import FilterSideShowViewCapsul from 'components/atoms/Filter/FilterSideShowViewCapsul';

import _ from 'lodash';
import {
    changeSelectAllOfCurrentAttrType,
    excludeIncludeEngine,
    removeAttrbuteNameByOnClick,
    removeAttributeType,
    removeEverythingForRespectiveAttrTypeOfApplyFilter,
} from 'parser/filterParser';
import React, { useContext } from 'react';
import { formatWord } from 'utils/helperMethods';

interface props {
    allCheckedAttribute: any;
    setAllCheckedAttribute: Function;
    setApplyFilterObject: Function;
    applyFilterObject: any;
    allSelectedValueForAllAttribute: any;
    setAllSelectedValueForAllAttribute: any;
    listOfAttrType: any;
    setAttributeTypeExpandClose: any;
    attributeTypes: any;
    screenFilterConfig: any;
}

export default function FilterExpandAttributeView({
    allCheckedAttribute,
    setAllCheckedAttribute,
    setApplyFilterObject,
    applyFilterObject,
    allSelectedValueForAllAttribute,
    setAllSelectedValueForAllAttribute,
    listOfAttrType,
    setAttributeTypeExpandClose,
    attributeTypes,
    screenFilterConfig,
}: props) {
    const disabledAttributeTypes: string[] = screenFilterConfig?.disabledAttributeTypes ?? [];
    function onClickOfAttributeCapsule(
        allCheckedAttribute: any,
        attributeName: string,
        attributeType: string,
        setAllCheckedAttribute: Function,
        allSelectedValueForAllAttribute: any,
    ) {
        setAllCheckedAttribute(removeAttrbuteNameByOnClick(allCheckedAttribute, attributeName, attributeType));

        //write code for updating applyFilterObject
        let e: any = { target: { checked: false } };
        let dimensionTemp: any = { dimensionReference: allCheckedAttribute[attributeType][attributeName].dimension };

        excludeIncludeEngine(
            allCheckedAttribute[attributeType][attributeName],
            e,
            attributeType,
            applyFilterObject,
            setApplyFilterObject,
            dimensionTemp,
            allSelectedValueForAllAttribute,
        );
        setAttributeTypeExpandClose('');
    }
    function onClickOfAttributeTypeClear(allCheckedAttribute: any, attributeType: string, listOfAttrType: any) {
        //to remove the from allCheck attribute
        setAllCheckedAttribute(() => removeAttributeType(allCheckedAttribute, attributeType));
        //to remove the inclusion and exclusion for the current attribute type
        setApplyFilterObject(() =>
            removeEverythingForRespectiveAttrTypeOfApplyFilter(applyFilterObject, attributeType, listOfAttrType),
        );
        //set all select state of all attribute type false as we remove the side bar
        setAllSelectedValueForAllAttribute(() =>
            changeSelectAllOfCurrentAttrType(allSelectedValueForAllAttribute, attributeType),
        );
        setAttributeTypeExpandClose('');
    }
    return (
        <div className="px-3.2 flex-col overflow-y-auto h-[51vh]">
            {Object.keys(allCheckedAttribute).map((attributeType) => {
                const isAttributeDisabled = disabledAttributeTypes?.includes(_.snakeCase(attributeType));
                return (
                    <div className="mt-4" key={attributeType}>
                        {Object.keys(allCheckedAttribute[attributeType]).length > 0 && (
                            <div className="mb-4 flex justify-between items-center" key={attributeType}>
                                <span className="font-sm font-medium">{formatWord(attributeType)}</span>
                                <span
                                    className={`font-xs text-purpleFont font-medium ${
                                        isAttributeDisabled ? 'pointer-events-none' : 'cursor-pointer'
                                    }`}
                                    onClick={() => {
                                        if (isAttributeDisabled) return;
                                        onClickOfAttributeTypeClear(allCheckedAttribute, attributeType, listOfAttrType);
                                    }}
                                >
                                    Clear
                                </span>
                            </div>
                        )}
                        <FilterSideShowViewCapsul
                            isAttributeDisabled={isAttributeDisabled}
                            attributeTypes={attributeTypes}
                            allCheckedAttribute={allCheckedAttribute}
                            attributeType={attributeType}
                            setAllCheckedAttribute={setAllCheckedAttribute}
                            onClickOfAttributeCapsule={onClickOfAttributeCapsule}
                            allSelectedValueForAllAttribute={allSelectedValueForAllAttribute}
                        />
                    </div>
                );
            })}
        </div>
    );
}
